import PropTypes from "prop-types";

import "../../styles/GroupShareTable.scss";

const PermissionDropdown = ({ criteriaKey, isActiveAndIsUnreleased, shareKey, current, onChange }) => {
    const handleChange = (e) => {
        const newValue = e.target.value;
        onChange(shareKey, criteriaKey, newValue);
    };

    return (
        <>
            <label className="visually-hidden" htmlFor={`sharePermissionDropdown-${criteriaKey}`}>
                Permission Dropdown
            </label>
            <select
                className={`permission-dropdown ${current}`}
                disabled={!isActiveAndIsUnreleased}
                id={`sharePermissionDropdown-${criteriaKey}`}
                value={current}
                onChange={handleChange}
            >
                <option value="none">Not Shared</option>
                <option value="view">View</option>
                <option value="edit">Edit</option>
            </select>
        </>
    );
};
PermissionDropdown.propTypes = {
    criteriaKey: PropTypes.string.isRequired,
    isActiveAndIsUnreleased: PropTypes.bool,
    shareKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    current: PropTypes.oneOf(["view", "edit", "none"])
};

PermissionDropdown.defaultProps = {
    isActiveAndIsUnreleased: false
};

export default PermissionDropdown;
